import useAddPost from "../hooks/useAddPost";
import { InputField, UploadImageField } from "@/components/Form";
import { Button, Image, ImageList } from "@/components/Elements";
import { PostHeader } from "./addPost";
import { AIInput } from "@/features/misc/components";
import { FileModel } from "@/types/common";
import { PostType } from "../types";

export const AddArticleScreen = () => {
  const {
    formState,
    getValues,
    register,
    setValue,
    postHeaderDetail,
    handleUploadImg,
    handleSubmit,
    handleSave,
    handleDraft,
  } = useAddPost({ type: PostType.Article });
  const { files } = getValues();

  return (
    <>
      <div className="p-0 mt-[10px] pb-[10px]">
        <div className="flex p-[5px]">
          <PostHeader {...postHeaderDetail} />
        </div>
        <InputField
          type="text"
          placeholder="Title"
          registration={register("title")}
          className="text-[20px]"
        />
        <div className="maz-h-[45%]">
          <InputField
            type="text"
            placeholder="Write something here..."
            registration={register("description")}
            error={formState.errors["description"]}
            className="text-[20px]"
          />
        </div>
        <div>
          <AIInput setValue={setValue} />
        </div>
        <div className="p-[17px] border-b border-b-[#d3d3d3]">
          <UploadImageField name="file" setValue={handleUploadImg}>
            <div className="flex">
              <Image src="add-image.png" className="w-[25px] h-[25px]" />
              <div className="text-[15px] ml-4 text-center">
                Add Image/Video
              </div>
            </div>
          </UploadImageField>
          {files && (
            <ImageList
              files={files}
              handleChange={(value: FileModel[]) => setValue("files", value)}
              showRemove
            />
          )}
        </div>
      </div>
      <div className="flex justify-between absolute bottom-3 z-10 bg-[#ffff] right-3 left-3">
        <Button onClick={handleSubmit(handleDraft)} className="w-[48%]">
          Save as draft
        </Button>
        <Button onClick={handleSubmit(handleSave)} className="w-[48%]">
          Publish
        </Button>
      </div>
    </>
  );
};
